import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    activeIntegrations: null,
    listingsCounts: {
        totalListingsCount: 0,
        totalDisabledListings: 0,
    },
};

export const integrationSlice = createSlice({
    name: 'integrations',
    initialState,
    reducers: {
        setActiveIntegrations: (state, action) => {
            state.activeIntegrations = action.payload;
        },
        setListingsCounts: (state, action) => {
            state.listingsCounts = action.payload;
        },
    },
});

export const { setActiveIntegrations, setListingsCounts } = integrationSlice.actions;

export default integrationSlice.reducer;
